import { COMMON_ERROR } from 'utils/ErrorMessages'

import {
  ADD_NEW_TAG,
  CHANGE_TYPE_OF_FORM,
  FETCH_TAGS_CAN_BE_ADDED_ASYNC,
  FETCH_TAGS_CAN_BE_REMOVED_ASYNC,
  RESET_TAGS_FORM_VALUES,
  SET_TAGS_CAN_BE_ADDED_PAGE,
  SET_TAGS_CAN_BE_ADDED_SEARCH,
  SET_TAGS_CAN_BE_REMOVED_PAGE,
  SET_TAGS_CAN_BE_REMOVED_SEARCH,
  TAGS_FORM_SUBMIT_ASYNC,
  TO_ADD_TAGS_CHANGE,
  TO_REMOVE_TAGS_CHANGE,
} from './constants'

const defaultTagsObject = {
  items: [],
  page: 1,
  search: '',
  loader: false,
  error: null,
  totalPages: 1,
}

export default function () {
  const initialState = {
    loader: false,
    error: null,
    status: false,
    message: null,
    typeOfForm: 1,
    tagsCanBeAdded: { ...defaultTagsObject },
    toAddTags: [],
    tagsCanBeRemoved: { ...defaultTagsObject },
    toRemoveTags: [],
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case TAGS_FORM_SUBMIT_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          message: null,
          status: false,
          error: null,
        }
      case TAGS_FORM_SUBMIT_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          loader: false,
          status: true,
        }
      case TAGS_FORM_SUBMIT_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
          message: action.error.response.message || COMMON_ERROR,
        }
      case TAGS_FORM_SUBMIT_ASYNC.CANCEL:
        return { ...state, loader: false }
      case FETCH_TAGS_CAN_BE_ADDED_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
          tagsCanBeAdded: {
            ...state.tagsCanBeAdded,
            loader: true,
            error: null,
          },
        }
      case FETCH_TAGS_CAN_BE_ADDED_ASYNC.SUCCESS: {
        const tags = action.payload.data.response.tags.map((elem) => ({
          name: elem.name,
          id: elem.id,
          type: elem.auto_tag_type,
        }))

        return {
          ...state,
          tagsCanBeAdded: {
            ...state.tagsCanBeAdded,
            items:
              state.tagsCanBeAdded.page === 1 ? tags : [...state.tagsCanBeAdded.items, ...tags],
            totalPages: action.payload.data.response.lastPageNum,
            loader: false,
          },
        }
      }
      case FETCH_TAGS_CAN_BE_ADDED_ASYNC.ERROR:
        return {
          ...state,
          message: COMMON_ERROR,
          tagsCanBeAdded: {
            ...state.tagsCanBeAdded,
            loader: false,
            error: action.error,
          },
        }
      case FETCH_TAGS_CAN_BE_ADDED_ASYNC.CANCEL:
        return {
          ...state,
          tagsCanBeAdded: {
            ...state.tagsCanBeAdded,
            loader: false,
          },
        }
      case SET_TAGS_CAN_BE_ADDED_PAGE:
        return {
          ...state,
          tagsCanBeAdded: {
            ...state.tagsCanBeAdded,
            page: action.payload.page,
          },
        }
      case SET_TAGS_CAN_BE_ADDED_SEARCH:
        return {
          ...state,
          tagsCanBeAdded: {
            ...state.tagsCanBeAdded,
            search: action.payload.search,
          },
        }
      case ADD_NEW_TAG: {
        const newTag = action.payload.value
        return {
          ...state,
          toAddTags: state.toAddTags.map((tag) => tag.label).includes(newTag.label)
            ? state.toAddTags
            : [...state.toAddTags, newTag],
        }
      }
      case FETCH_TAGS_CAN_BE_REMOVED_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
          tagsCanBeRemoved: {
            ...state.tagsCanBeRemoved,
            loader: true,
            error: null,
          },
        }
      case FETCH_TAGS_CAN_BE_REMOVED_ASYNC.SUCCESS: {
        const tags = action.payload.data.response.tags.map((elem) => ({
          name: elem.name,
          id: elem.id,
          type: elem.auto_tag_type,
        }))

        return {
          ...state,
          tagsCanBeRemoved: {
            ...state.tagsCanBeRemoved,
            items:
              state.tagsCanBeRemoved.page === 1 ? tags : [...state.tagsCanBeRemoved.items, ...tags],
            totalPages: action.payload.data.response.lastPageNum,
            loader: false,
          },
        }
      }
      case FETCH_TAGS_CAN_BE_REMOVED_ASYNC.ERROR:
        return {
          ...state,
          message: COMMON_ERROR,
          tagsCanBeRemoved: {
            ...state.tagsCanBeRemoved,
            loader: false,
            error: action.error,
          },
        }
      case FETCH_TAGS_CAN_BE_REMOVED_ASYNC.CANCEL:
        return {
          ...state,
          tagsCanBeRemoved: {
            ...state.tagsCanBeRemoved,
            loader: false,
          },
        }
      case SET_TAGS_CAN_BE_REMOVED_PAGE:
        return {
          ...state,
          tagsCanBeRemoved: {
            ...state.tagsCanBeRemoved,
            page: action.payload.page,
          },
        }
      case SET_TAGS_CAN_BE_REMOVED_SEARCH:
        return {
          ...state,
          tagsCanBeRemoved: {
            ...state.tagsCanBeRemoved,
            search: action.payload.search,
          },
        }
      case TO_ADD_TAGS_CHANGE: {
        // This logic resolve case of adding tag from existed list before/after add new tag
        const customTags = state.toAddTags.filter((tag) => !tag.value)
        const newArray = [...customTags, ...action.payload.value]
        return {
          ...state,
          toAddTags: action.payload.value.length ? newArray.filter((tag) => tag.label) : [],
        }
      }
      case TO_REMOVE_TAGS_CHANGE:
        return {
          ...state,
          toRemoveTags: action.payload.value,
        }
      case RESET_TAGS_FORM_VALUES:
        return {
          ...state,
          tagsCanBeAdded: { ...defaultTagsObject },
          toAddTags: [],
          tagsCanBeRemoved: { ...defaultTagsObject },
          toRemoveTags: [],
        }
      case CHANGE_TYPE_OF_FORM:
        return {
          ...state,
          typeOfForm: state.typeOfForm === 0 ? 1 : 0,
        }
      default:
        return state
    }
  }
}
